<footer>
  <span>享受尊貴生活</span> <span>盡在生活會</span>
  <a href="/#/home-page">
    <img class="play" src="../../../../assets/image/home-page/-e-play-button.png" alt="play" />
  </a>
</footer>
